var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page",class:{
    en: _vm.$i18n.locale === 'en-US',
  }},[_c('LineDecoration'),_c('BannerList'),_c('AboutUs'),_c('CoreSection'),_c('OurProducts'),_c('div',{staticClass:"compoany"},[_c('cooperationPartner',{attrs:{"speed":5,"direction":'left'}})],1),_c('div',{staticClass:"footerss"},[_c('FooterComponents')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }